import {
    CLOSE_LOADER,
    SET_ERROR,
    SET_LOADER,
    SET_SUCCESS,
  } from "../Types/AuthTypes";
import { 
  SET_VENDOR_PAYMENT, 
  SET_SPECIFIC_VENDOR_PAYMENT, 
  RESET_SPECIFIC_VENDOR_PAYMENT } from "../Types/VendorPaymentType";
  import backendVerifiedUser from "../../api/backendVerifiedUser";
  
  export const addVendorPayment = (data) => {
    return async (dispatch) => {
      dispatch({ type: SET_LOADER });
      try {
        const response = await backendVerifiedUser.post(
          "/add-vendor-payment",
          data
        );
        dispatch({ type: CLOSE_LOADER });
        console.log(data)
        dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
  
        return true;
      } catch (err) {
        dispatch({ type: CLOSE_LOADER });
        console.log(err);
        dispatch({
          type: SET_ERROR,
          payLoad: err.response?.data?.error?.msg,
        });
        return false;
      }
    };
  };
  
  export const getVendorPayment = () => {
    return async (dispatch) => {
      dispatch({ type: SET_LOADER });
      try {
        const response = await backendVerifiedUser.get("/get-vendor-payment");
        dispatch({ type: CLOSE_LOADER });
  
        dispatch({ type: SET_VENDOR_PAYMENT, payLoad: response.data });
  
        return true;
      } catch (err) {
        dispatch({ type: CLOSE_LOADER });
        console.log(err);
        dispatch({
          type: SET_ERROR,
          payLoad: err.response?.data?.error?.msg,
        });
        return false;
      }
    };
  };

  export const getSpecificVendorPayment = (id) => {
    return async (dispatch) => {
      dispatch({ type: SET_LOADER });
      try {
        const response = await backendVerifiedUser.get(
          `/get-specific-vendor-payment/${id}`
        );
        console.log("response ------>", response);
        dispatch({ type: CLOSE_LOADER });
  
        dispatch({ type: SET_SPECIFIC_VENDOR_PAYMENT, payLoad: response.data });
      } catch (err) {
        dispatch({ type: CLOSE_LOADER });
        console.log(err);
        dispatch({
          type: SET_ERROR,
          payLoad: err.response?.data?.error?.msg,
        });
      }
    };
  };

  export const updateVendorPayment = (data, id) => {
    return async (dispatch) => {
      dispatch({ type: SET_LOADER });
      try {
        const response = await backendVerifiedUser.post(
          `/update-vendor-payment/${id}`,
          data
        );
        dispatch({ type: CLOSE_LOADER });
  
        dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
        dispatch({ type: RESET_SPECIFIC_VENDOR_PAYMENT });
        return true;
      } catch (err) {
        dispatch({ type: CLOSE_LOADER });
        console.log(err);
        dispatch({
          type: SET_ERROR,
          payLoad: err.response?.data?.error?.msg,
        });
      }
    };
  };
  


  